import { useEffect, useRef } from 'react';

/**
 * Port of the Compose `AlertDialog`s the parent dashboard uses before its
 * two irreversible actions (unpair a device, delete a child). Built on
 * `<dialog showModal>` so focus trapping, Escape-to-dismiss and the
 * backdrop come from the platform rather than from hand-rolled key
 * handling.
 */
export function ConfirmDialog({
  title,
  body,
  confirmLabel,
  destructive = false,
  onConfirm,
  onDismiss,
}: {
  title: string;
  body: string;
  confirmLabel: string;
  destructive?: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  return (
    <dialog ref={dialogRef} className="dialog" onCancel={onDismiss} onClose={onDismiss}>
      <h2 className="dialog__title">{title}</h2>
      <p className="dialog__body">{body}</p>
      <div className="dialog__actions">
        <button type="button" className="button button--text" onClick={onDismiss}>
          Abbrechen
        </button>
        <button
          type="button"
          className={destructive ? 'button button--text button--danger' : 'button button--text'}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </dialog>
  );
}
